import { Injectable, NgModuleRef } from '@angular/core';
import { Configurator } from './configurator';

@Injectable()
export abstract class AbstractConfiguratorsRepositoryService {
    static configurators: Record<string, Record<number, Configurator>> = {};
    static moduleRefs: Record<string, NgModuleRef<any>> = {};
    static configServiceClasses: Record<string, any> = {};

    static getConfigurator(type: string, id = 0) {
        if (!this.configurators[type]?.[id]) {
            throw new Error(`Configurator ${type} (${id}) is not loaded!`);
        }
        return this.configurators[type][id];
    }

    static getModuleRef(type: string) {
        if (!this.moduleRefs[type]) {
            throw new Error(`Configurator ${type} is not loaded!`);
        }
        return this.moduleRefs[type];
    }

    static getName(type: string, id?: number) {
        const configurator = this.getConfigurator(type, id);
        if (!configurator.name && configurator.parent) {
            return configurator.parent.name();
        }
        return configurator.name();
    }

    static getStepsComponents(type: string, id?: number) {
        const configurator = this.getConfigurator(type, id);
        if (!configurator.stepsComponents && configurator.parent) {
            return configurator.parent.stepsComponents;
        }
        return configurator.stepsComponents;
    }

    static getSteps(type: string, id?: number) {
        const configurator = this.getConfigurator(type, id);
        if (!configurator.stepsProvider && configurator.parent) {
            return configurator.parent.stepsProvider;
        }
        return configurator.stepsProvider;
    }

    static getDataLoader(type: string, id?: number) {
        const configurator = this.getConfigurator(type, id);
        if (!configurator.dataLoader && configurator.parent) {
            return configurator.parent.dataLoader;
        }
        return configurator.dataLoader;
    }

    static getGroupEdit(type: string, id?: number) {
        const configurator = this.getConfigurator(type, id);
        if (!configurator.groupEdit && configurator.parent) {
            return configurator.parent.groupEdit;
        }
        return configurator.groupEdit;
    }

    static getOnInit(type: string, id?: number) {
        const configurator = this.getConfigurator(type, id);
        if (!configurator.onInit && configurator.parent) {
            return configurator.parent.onInit;
        }
        return configurator.onInit;
    }
    static getConfigurations(type: string, id?: number) {
        const configurator = this.getConfigurator(type, id);

        if (!configurator.configurations && configurator.parent) {
            return configurator.parent.configurations;
        }
        return configurator.configurations;
    }

    static getConfiguratorOptions(type: string, id?: number) {
        const configurator = this.getConfigurator(type, id);
        if (!configurator.configuratorOptions && configurator.parent) {
            return configurator.parent.configuratorOptions;
        }
        return configurator.configuratorOptions;
    }

    static hasAdvancedDetails(type: string, id?: number) {
        const configurator = this.getConfigurator(type, id);
        return configurator.hasAdvancedDetails;
    }

    static getDetailsTree(type: string, id?: number) {
        const configurator = this.getConfigurator(type, id);
        if (!configurator.getDetailsTree && configurator.parent) {
            return configurator.parent.getDetailsTree;
        }
        return configurator.getDetailsTree;
    }

    static getPositionTitle(type: string, id?: number) {
        const configurator = this.getConfigurator(type, id);
        if (!configurator.getPositionTitle && configurator.parent) {
            return configurator.parent.getPositionTitle;
        }
        return configurator.getPositionTitle;
    }

    static getSpareParts(type: string, id?: number) {
        const configurator = this.getConfigurator(type, id);
        if (!configurator.spareParts && configurator.parent) {
            return configurator.parent.spareParts;
        }
        return configurator.spareParts;
    }

    static getOfferPriceRecalculation(type: string, id?: number) {
        const configurator = this.getConfigurator(type, id);
        if (!configurator.offerPriceRecalculation && configurator.parent) {
            return configurator.parent.offerPriceRecalculation;
        }
        return configurator.offerPriceRecalculation;
    }

    abstract loadConfigurator(type: string, id: number): Promise<void>;
}
